import ExternalAudience from 'owa-service/lib/contract/ExternalAudience';
import MailboxAutoReplyConfigurationOptions from 'owa-service/lib/contract/MailboxAutoReplyConfigurationOptions';

/**
 * Util to determine if Automatic replies is enabled only to the organization.
 * @param autoReplyConfigOptions automatic replies options
 */
export default function isAutomaticRepliesOnlyToMyOrganizationUtil(
    autoReplyConfigOptions: MailboxAutoReplyConfigurationOptions
): boolean {
    return autoReplyConfigOptions.ExternalAudience === ExternalAudience.None;
}
